import { render, staticRenderFns } from "./PagePermaLink.vue?vue&type=template&id=3125afb1"
import script from "./PagePermaLink.vue?vue&type=script&lang=js"
export * from "./PagePermaLink.vue?vue&type=script&lang=js"
import style0 from "./PagePermaLink.vue?vue&type=style&index=0&id=3125afb1&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports